import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import homeLogo from './assets/logo.svg';
import Type from "./components/home/type";
import './App.css';

function App() {
  return (
    <div className="App">

      <header className="App-header">
        {/* <img src={homeLogo} className="App-logo" alt="logo" /> */}
        <section>
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Software Developer </strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
          </Row>
      </Container>
    </section>
    <a
          className="App-link"
          href="https://www.linkedin.com/in/rhs26797/"
          target="_blank"
          rel="noopener noreferrer"
        >
          More...
        </a>
      </header>
    </div>
  );
}

export default App;
